import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilterItem from '@/listing-delonghi/components/filters/FilterItem';
import FilterColorItem from '@/listing-delonghi/components/filters/FilterColorItem';

const FiltersMenuDesktop = ({ filtersData }) => {
  const { t } = useTranslation();
  const { facets } = filtersData;
  const facetElements = facets
    ? facets.map(facet =>
        facet.code === 'baseColor' ? (
          <FilterColorItem filter={facet} key={facet.code} />
        ) : (
          <FilterItem filter={facet} key={facet.code} />
        ),
      )
    : null;

  return (
    <div className='del-plp-filters__filters-menu-desktop'>
      <div className='del-plp-filters__filters-menu-desktop-label'>
        <span>{t('listing:listing.filter.desktop.cta.label')}</span>
      </div>
      {facetElements}
    </div>
  );
};

FiltersMenuDesktop.propTypes = {
  filtersData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FiltersMenuDesktop;
